import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../../api/axios";

// 🔥 SEO-safe slugify
const slugify = (text) =>
  text
    .toLowerCase()
    .normalize("NFD")                 // remove accents
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-z0-9 ]/g, "")       // remove symbols
    .trim()
    .replace(/\s+/g, "-");            // spaces → -

export default function CategoriesGrid() {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/categories")
      .then((res) => {
        setCategories(res.data.data); // Laravel API returns { success: true, data: [...] }
      })
      .catch((err) => console.error(err))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <p className="text-center py-10">Loading categories...</p>;

  return (
    <section className="max-w-8xl mx-auto px-4 py-5 md:py-10">
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-6">
        {categories.map((cat) => (
          <Link
            key={cat.id}
            to={`/categorie/${slugify(cat.name)}`}
            className="block rounded-xl overflow-hidden transition-transform duration-300 h-[4.7rem] md:h-[6.4rem] hover:scale-[1.02]"
          >
            <img
              src={`${process.env.REACT_APP_BACKEND_URL}${cat.image}`}
              alt={cat.name}
              className="w-full rounded-xl h-[auto] shadow-sm hover:shadow-md"
              loading="lazy"
            />
          </Link>
        ))}
      </div>
    </section>
  );
}